//添加设计资源
import { useEffect, useState } from "react";
import { Card, Form, Image, Upload, Button, Space, Select, message, Input, Spin } from "antd"
import { useTranslation } from "react-i18next";
import { UploadOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';

import { uploadFileAPI } from '@/apis/file';
import { useShowLocationList } from "@/hooks/useShowLocationList";
import { useProjectList } from "@/hooks/useProjectList";
import { addDesignAPI } from "@/apis/design";

const { Option } = Select

const layout = {
    labelCol: {
        span: 6,
        style: {
            whiteSpace: 'normal',
            lineHeight: '1.4',
            textAlign: 'right',
            fontWeight: '500',
            paddingRight: '12px',
        }
    },
    wrapperCol: {
        span: 18,
    },
};
const tailLayout = {
    wrapperCol: {
        offset: 8,
        span: 16,
    },
};

const handleFileValueChange = (e) => {

}

const handleImgValueChange = (e) => {
}

const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

//通过接口上传文件
async function uploadFileByAPI(file) {
    let formData = new FormData()
    formData.append('file', file)
    try {
        let res = await uploadFileAPI(formData)
        const filename = JSON.stringify(res.data).trim().replace(/^"|"$/g, '');
        const data = {
            name: filename,
            code: res.code
        }
        return data
    } catch (error) {
        console.error("Error uploading file:", error);
    }
}

const AddDesignRes = () => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [fileList, setFileList] = useState([])
    const [desFileList, setDesFileList] = useState([])
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');

    const { showLocationList } = useShowLocationList()
    const { projectList } = useProjectList()

    const { t } = useTranslation();

    const [form] = Form.useForm();

    const onReset = () => {
        form.resetFields();
    };

    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e?.fileList;
    };

    const beforeImgUpload = (file) => {
        // 文件上传前的校验逻辑
        // 校检文件类型
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('You can only upload JPG/PNG file!');
            return isJpgOrPng
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('Image must smaller than 2MB!');
            return isLt2M
        }
        return false;
    };

    //设计文件上传校验
    const beforeDesFileUpload = (file) => {
        // 文件上传前的校验逻辑
        // 校检文件类型

        const isText = file.type === 'text/plain';
        if (!isText) {
            message.error('You can only upload text/plain file!');
            return isText
        }
        // const isLt2M = file.size / 1024 / 1024 < 2;
        // if (!isLt2M) {
        //   message.error('Image must smaller than 2MB!');
        //   return isLt2M
        // }
        return false;
    };

    const handlePreview = async (file) => {

        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };

    const onFinish = async (values) => {
        if (fileList[0].originFileObj == null || desFileList[0].originFileObj == null) {
            messageApi.error("上传文件为空！")
        } else {
            let imgRes, desFileRes;
            try {
                imgRes = await uploadFileByAPI(fileList[0].originFileObj)
            } catch (error) {
                console.error("Error uploading image file:", error);
            }
            try {
                desFileRes = await uploadFileByAPI(desFileList[0].originFileObj)
            } catch (error) {
                console.error("Error uploading design file:", error);
            }
            if (imgRes.code === 1 || desFileRes.code === 1) {
                messageApi.error("上传文件为空！")
            } else {
                values.designFile = desFileRes
                const uploadDesFile = {
                    projectId: values.projectId,
                    positionPhoto: imgRes.name,
                    otherInfo: values.info,
                    designFile: desFileRes.name,
                    positionId: values.positionId
                }
                try {
                    let res = await addDesignAPI(uploadDesFile);
                    messageApi.info(res.msg);
                    if (res.code === 0) {
                        setFileList([]);
                        setDesFileList([]);
                        onReset();
                    }
                } catch (error) {
                    console.error("Error adding design resource:", error);
                }
            }
        }
    }

    const handleChange = ({ fileList: newFileList }) => {
        setFileList(newFileList)
    };
    const handleDesFileChange = ({ fileList: newFileList1 }) => {
        setDesFileList(newFileList1)
    };
    const uploadButton = (
        <button
            style={{
                border: 0,
                background: 'none',
            }}
            type="button"
        >
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div
                style={{
                    marginTop: 8,
                }}
            >
                Upload
            </div>
        </button>
    );

    return (
        <Card
            style={{
                width: '100%',
                minHeight: '100%',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                borderRadius: '8px',
                overflow: 'hidden',
            }}
            title={t('DesignRes.FormList.Title')}
            styles={{
                body: {
                    padding: '0',
                    height: '100%',
                    overflow: 'auto',
                }
            }}
        >
            {contextHolder}
            <Spin spinning={loading} size="large" />
            <div style={{
                width: '100%',
                padding: '20px',
                maxHeight: 'calc(100vh - 120px)',
                overflowY: 'auto',
                overflowX: 'hidden',
            }}>
                <Form
                    {...layout}
                    form={form}
                    name="control-hooks"
                    onFinish={onFinish}
                    style={{
                        width: '100%',
                        maxWidth: '800px',
                        margin: '0 auto',
                        minWidth: '0',
                        boxSizing: 'border-box',
                    }}
                    encType='multipart/form-data'
                    size="large"
                >

                    <Form.Item
                        name="projectId"
                        label={t('DesignRes.FormList.ProjectName')}
                        rules={[
                            {
                                required: true,
                                message: `${t('DesignRes.FormList.ProjectNameMessage')}`,
                            },
                        ]}
                    >
                        <Select style={{ width: 200 }}>
                            {projectList.map(item => <Option key={item.id} value={item.id}>{item.projectName}</Option>)}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="positionId"
                        label={t('DesignRes.FormList.PositionName')}
                        rules={[
                            {
                                required: true,
                                message: `${t('DesignRes.FormList.PositionNameMessage')}`,
                            },
                        ]}
                    >
                        <Select style={{ width: 200 }}>
                            {showLocationList.map(item => <Option key={item.id} value={item.id}>{item.placeName}</Option>)}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        valuePropName="image"
                        label={t('DesignRes.FormList.PositionPhoto')}
                        getValueFromEvent={handleImgValueChange}
                        rules={[
                            {
                                required: true,
                                message: `${t('DesignRes.FormList.PositionPhotoMessage')}`,
                            },
                        ]}
                    >
                        <Upload
                            listType="picture-card"
                            fileList={fileList}
                            onPreview={handlePreview}
                            onChange={handleChange}
                            beforeUpload={beforeImgUpload}
                        >
                            {fileList.length >= 1 ? null : uploadButton}
                        </Upload>
                        {previewImage && (
                            <Image
                                wrapperStyle={{
                                    display: 'none',
                                }}
                                preview={{
                                    visible: previewOpen,
                                    onVisibleChange: (visible) => setPreviewOpen(visible),
                                    afterOpenChange: (visible) => !visible && setPreviewImage(''),
                                }}
                                src={previewImage}
                            />
                        )}
                    </Form.Item>

                    <Form.Item
                        name="designFile"
                        label={t('DesignRes.FormList.DesignFile')}
                        valuePropName="designFile"
                        getValueFromEvent={normFile}
                        rules={[
                            {
                                required: true,
                                message: `${t('DesignRes.FormList.DesignFileMessage')}`,
                            },
                        ]}
                    >
                        <Upload
                            accept=".txt"
                            maxCount={1}
                            beforeUpload={beforeDesFileUpload}
                            fileList={desFileList}
                            onChange={handleDesFileChange}>
                            <Button style={{ width: 200 }} icon={<UploadOutlined />}>{t('ButtonList.UploadFile')}</Button>
                        </Upload>
                    </Form.Item>

                    <Form.Item
                        name="info"
                        label={t('DesignRes.FormList.OtherInfo')}
                        rules={[
                            {
                                required: false,
                                message: `${t('DesignRes.FormList.DesignFileMessage')}`,
                            },
                        ]}
                    >
                        <Input style={{ width: 200 }} />
                    </Form.Item>

                    <Form.Item {...tailLayout}>
                        <Space>
                            <Button type="primary" htmlType="submit">
                                {t('ButtonList.Submit')}
                            </Button>
                            <Button htmlType="button" onClick={onReset}>
                                {t('ButtonList.Reset')}
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </div>
        </Card >
    )
}

export default AddDesignRes